// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2lK-d","inner":"Form_inner__3nh9p","range":"Form_range__1LjRN","name":"Form_name__2Th3v","actions":"Form_actions__17v87"};